import { useState } from "react";
import { Gift, Droplets, Bone, Scissors, ArrowRight } from "lucide-react";
import { OFFERS, OFFER_NOTE } from "../data/mock";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import OfferClaim from "./OfferClaim";

const ICONS = { "oil-massage": Droplets, "toy-pack-549": Gift, "toy-pack-349": Bone, dematting: Scissors };

export function OfferDialog({ open, onOpenChange, defaultOffer, source }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="offer-claim-dialog" className="max-h-[90vh] overflow-y-auto border-0 bg-white sm:max-w-md rounded-3xl">
        <DialogTitle className="font-heading text-2xl text-[#3915AA]">Claim your free offer</DialogTitle>
        <DialogDescription className="text-sm text-[#1E0A5C]/60">Pick one offer and get a unique code to use when booking.</DialogDescription>
        <OfferClaim key={defaultOffer} defaultOffer={defaultOffer} source={source} />
      </DialogContent>
    </Dialog>
  );
}

export default function OffersSection({ source = "section" }) {
  const [open, setOpen] = useState(null);
  return (
    <section id="offers" data-testid="offers-section" className="container-custom py-16 md:py-20 scroll-mt-28">
      <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#FC5106]">Current offers</p>
          <h2 className="font-heading text-3xl font-bold text-white sm:text-4xl">Pick a free treat with your booking</h2>
          <p className="mt-2 text-sm text-white/60">{OFFER_NOTE}</p>
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {OFFERS.map((o) => {
          const Icon = ICONS[o.id];
          return (
            <button key={o.id} onClick={() => setOpen(o.id)} data-testid={`offer-card-${o.id}`} className="card-lift group flex flex-col rounded-3xl border border-white/10 bg-[#2E0F94] p-6 text-left">
              <span className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#FC5106] text-white">
                <Icon className="h-5 w-5" />
              </span>
              <span className="text-xs font-bold uppercase tracking-wider text-[#FC5106]">{o.tag}</span>
              <span className="mt-1 font-heading text-xl font-bold text-white">{o.title}</span>
              <span className="mt-2 flex-1 text-sm text-white/60">{o.detail}</span>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-white">
                Get my code <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </button>
          );
        })}
      </div>
      <OfferDialog open={!!open} onOpenChange={(v) => !v && setOpen(null)} defaultOffer={open || OFFERS[0].id} source={source} />
    </section>
  );
}
